<script setup lang="ts">
  defineProps<{
    icon: string,
    title: string,
    description?: string,
    unrequested?: boolean,
    unrequestedTitle?: string,
    unrequestedDescription?: string,
  }>()
</script>

<template>
  <div class="text-center py-12">
    <div class="text-gray-500 text-4xl">
      <fa-icon :icon="icon" />
    </div>
    <p class="text-gray-500 text-xl font-semibold mt-4 mb-2">
      {{ unrequested ? unrequestedTitle : title }}
    </p>
    <p
      v-if="description"
      class="text-gray-400 text-sm">
      {{ unrequested ? unrequestedDescription : description }}
    </p>
    <slot></slot>
  </div>
</template>
